import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-studikasus',
  templateUrl: './studikasus.component.html',
  styleUrls: ['./studikasus.component.scss']
})
export class StudikasusComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
